import { createContext, useContext, useState } from "react";

import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

// create context for managing errors
const Context = createContext({
  setError: (error: { message: string; reset: () => void }) => {},
});

// custom hook to use the error context
export const useError = () => useContext(Context);

// banner component
const Banner = (props: { message: string; clear: () => void }) => {
  const { message, clear } = props;

  return (
    <Snackbar
      key={message}
      open={!!message}
      onClose={clear}
      autoHideDuration={10000}
    >
      <Alert onClose={clear} severity="error">
        {message}
      </Alert>
    </Snackbar>
  );
};

// error provider component
const ErrorProvider = ({ children }: { children: any }) => {
  const [reset, setReset] = useState(Function);
  const [message, setMessage] = useState("");

  // function to set error message + reset method
  const setHandler = (error: { message: string; reset: () => void }) => {
    setReset(() => error.reset);
    setMessage(error.message);
  };

  // function to clear error message & reset query
  const clear = () => {
    // reset message
    setMessage("");

    // reset failed query
    reset();
  };

  return (
    <Context.Provider value={{ setError: setHandler }}>
      {children}
      <Banner message={message} clear={clear} />
    </Context.Provider>
  );
};

export default ErrorProvider;
